import { useEffect } from 'react';
import { setSentryUser, addBreadcrumb } from '../sentry.config';
import { useGetGeneralSettingsQuery } from '../services/settingsSlice';
import { getCurrentCognitoUser } from '../services/auth';

export const useSentryUser = () => {

  // Check if user is authenticated by checking Cognito session or localStorage
  const checkAuth = () => {
    try {
      const cognitoUser = getCurrentCognitoUser();
      const token = localStorage.getItem('token');
      const userEmail = localStorage.getItem('oogw.ai_user_email');
      return !!(cognitoUser || token || userEmail);
    } catch {
      return false;
    }
  };

  const isAuth = checkAuth();


  // console.log("assssssssssssss",isAuth);
  

  useEffect(() => {
    // Skip if loading user data

    if (isAuth) {
      // Get email from localStorage or getUserData
      const userEmail =  localStorage.getItem('oogw.ai_user_email') || localStorage.getItem('oogw.ai_shadow_user_email') || undefined;

      const sentryUserData = {
        id: userEmail || undefined,
        email: userEmail,
        workspace_id: localStorage.getItem('workspace_id') || undefined,
      };

      // Always update Sentry user context
      setSentryUser(sentryUserData);

      addBreadcrumb({
        message: 'User context set',
        category: 'auth',
        level: 'info',
        data: {
          userId: sentryUserData.id,
          workspaceId: sentryUserData.workspace_id,
        },
      });
    }
    // Don't clear Sentry user - keep context even if not authenticated

    return () => {
      // Don't clear on unmount - keep user context
    };
  }, [isAuth]); // Include isLoading to wait for data
};

export default useSentryUser;